<template>

  <div>

    <xolas-table
        :title="'Request to ' + this.heading"
        :id="this.type.toLowerCase() + '-action-table'"
        :table-ref="this.type.toLowerCase() + '-action-table'"

        :url="'/view/actions/' + (this.telcoId ? this.type + '/' + this.telcoId : this.type + '/null') + '/' + reqStatus"

        :fields="fields"

        :sort-field="sortField + '|' + sortDir"
        :sort-direction="sortDir.toUpperCase()"

        search-placeholder="Site Names, Site IDs, Status, Timeline..."
        :show-refresh="true"
        :show-search="true"

        :layer-component="disableLayer ? null : 'request'"
        :layer-args="{ id: 'id' }"
        ref="reqTable">

        <template #actions>
          <request-action
            v-if="canCreateRequest()"
            :type="type"
            :row-data="actionStruct" />
        </template>

        <!-- Mirrors dev/production order: filter strip + sort dropdown sit
             BETWEEN the search/filter-bar and the data rows, not above them.
             -->
        <template #below-filter>
          <request-stats
            class="request-stats"
            :status="reqStatus"
            :active="active"
            :rejected="rejected"
            :closed="closed"
            :change="changed" />

          <el-row class="request-sort-bar" type="flex" justify="center" align="middle">
            <el-col align="left" :span="3">
              <i class="text-muted">Sort by:</i>
            </el-col>
            <el-col align="center" :span="18">
              <el-select v-model="sortField" size="small" class="request-sort-bar__select" @change="applySort" placeholder="Sort field">
                <el-option v-for="opt in sortOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
              </el-select>
            </el-col>
            <el-col align="right" :span="3">
              <el-tooltip :content="sortField + ': ' + sortDir" placement="top">
                <el-switch
                  v-model="sortDir"
                  active-icon-class="fa fa-sort-amount-up text-success"
                  inactive-icon-class="fa fa-sort-amount-down text-danger"
                  active-value="asc"
                  inactive-value="desc"
                  @change="applySort" />
              </el-tooltip>
            </el-col>
          </el-row>
        </template>

        <!-- XolasTable forwards #empty into el-table's empty slot.
             Element UI 2.x does NOT ship <el-empty> (that's Element Plus / Vue 3),
             so we hand-roll the empty state. -->
        <template #empty>
          <div class="requests-empty">
            <i class="fa fa-share-alt requests-empty__icon" />
            <p class="requests-empty__text">No {{ heading.toLowerCase() }} requests</p>
            <p class="requests-empty__sub">There are no {{ reqStatus }} requests in this category yet.</p>
          </div>
        </template>

        <template #request-details="props">

          <el-row :gutter="8.52" :class="formatBG(props.rowData.actionType)" style="padding: 0.852em">

            <el-col :xs="24" :sm="24" :md="24" :lg="12">

            <el-col :span="24">

              <h3 :class="formatRequest(props.rowData.actionType)">
                <org-badge v-if="!isTelco()" :short-name="props.rowData.shortName" :color="props.rowData.colourCode" />
                <div class="pull-right" v-if="props.rowData.actionType === 'RTB' && props.rowData.provider_id">
                  <h5>Provider: <org-badge :short-name="props.rowData.providerShortName" :color="props.rowData.providerColourCode"  />&nbsp;<b class="text-black">{{props.rowData.backhaulType}}</b></h5>
                </div>
              </h3>


              <h4 :class="formatRequest(props.rowData.actionType)">
                <span v-if="(props.rowData.status === 'Rejected' || props.rowData.status === 'Closed')">
                  <b :class="(props.rowData.status === 'Rejected' ? 'text-warning' : 'text-success')">{{props.rowData.status}}</b>
                  &nbsp;|&nbsp;</span><b>
                    <el-badge v-if="props.rowData.status === 'NEW' || props.rowData.status === 'Pending'"
                      :value="props.rowData.status"
                      :type="props.rowData.status === 'Pending' ? 'warning' : 'danger'">
                      {{props.rowData.siteName}}
                    </el-badge>
                    <span v-else>{{props.rowData.siteName}}</span>
                  </b>
                <span v-if="props.rowData.telcoSiteId">&nbsp;({{props.rowData.telcoSiteId}})</span>
              </h4>


              <el-steps class="hidden-sm-and-down" :active="props.rowData.currentStep - 1" :finish-status="formatStep(props.rowData.actionType)" align-center direction="horizontal">
                <el-step v-for="s in props.rowData.stepWorkflow" :key="s.stepName" :description="s.stepName">
                  <template #icon>
                    <i :class="s.stepIcon" style="background: inherit;"></i>
                  </template>
                </el-step>
              </el-steps>

            </el-col>


            <el-col style="padding-top: 7.41px;" :xs="24" :sm="24" :md="24" :lg="24" align="left">

              <el-row :gutter="5.28">
                <el-col :xs="24" :sm="24" :md="24" :lg="14" align="left">
                 <el-progress v-if="props.rowData.currentStep >= 0 && props.rowData.totalSteps"
                    :stroke-width="26"
                    :percentage="(props.rowData.currentStep / props.rowData.totalSteps * 100)"
                    :color="progessBar(props.rowData.actionType)"
                    :text-inside="true" />
               </el-col>

               <el-col :xs="24" :sm="24" :md="24" :lg="10" :align="props.rowData.totalSteps ? 'center' : 'left'">

                <!-- eslint-disable-next-line vue/no-v-html -- formatter output, enum → coloured <b> markup -->
                <span v-html="formatPeriod(props.rowData.Period)" />&nbsp;|&nbsp;
                {{(props.rowData.Period === 'Finished' ? '' : 'Due:')}}
                {{formatDate((props.rowData.Period === 'Finished' ? props.rowData.actualDate : props.rowData.targetDate))}}
                &nbsp;|&nbsp;
                <b>{{formatFriendlyDate((props.rowData.Period === 'Finished' ? props.rowData.actualDate : props.rowData.targetDate))}}</b>

               </el-col>


               <el-col v-if="isDesktop && isTowerCo()" :span="24">
               <br />
                <h5>Client: <b>{{props.rowData.name}}</b></h5>
               </el-col>

            </el-row>


              <small>Ref: <i>{{props.rowData.siteId}}-{{props.rowData.id}}</i></small>

            </el-col>

          </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="12">
              <site-card :site-data="props.rowData" use-leaflet hide-site height="230px" />
            </el-col>
          </el-row>


        </template>

        <template #rts-controls="props">
          <rtx-action-delete-control :row-data="props.rowData" />
        </template>

    </xolas-table>

  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import SiteCard from '@/components/sites/SiteCard'
import { sanitiseHtml } from '@/lib/sanitiseHtml'

import RequestAction from '@/components/actions/RequestAction'
import RequestStats from '@/components/requests/RequestStats'
import RtxActionDeleteControl from '@/components/requests/RtxActionDeleteControl'

export default {

  mixins: [DateMixins],

  components: {
    SiteCard,
    RequestAction,
    RequestStats,
    RtxActionDeleteControl
  },

  props: {
    sharer: {
      type: Number,
      default: null
    },

    heading: {
      type: String,
      default: 'Share'
    },

    type: {
      type: String,
      default: 'RTS'
    },

    status: {
      type: String,
      default: 'active'
    },

    rejected: {
      type: Number,
      default: null
    },

    active: {
      type: Number,
      default: null
    },

    closed: {
      type: Number,
      default: null
    },

    disableLayer: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    /**
     * XOL-393: whether the create button (Share / Upgrade / Acquire / …) is rendered.
     *
     * The exact negation of the ROLE clause in RequestAction's `:disableButton`:
     *   disable when  isTowerCo() && !isManager('project|finance|admin')
     *   so show when  !isTowerCo() || isManager('project|finance|admin')
     *
     * Note the `isTowerCo()` qualifier is load-bearing. The role gate applies ONLY to
     * Tower Co; for every other category (Telco, Backhaul, Contractor, Landlord,
     * Authority, Utility, Supplier) RequestAction renders the button ENABLED regardless
     * of the manager flag, so this must not hide it from them.
     *
     * View-only is NOT checked here. RequestAction self-gates on `!isViewOnly()`
     * (XOL-393), which keeps that rule identical on all three surfaces the button
     * renders on. Duplicating it here is what caused the drift this ticket fixes.
     *
     * See docs/UX-architecture/access/edit-access-register.md for the register row.
     */
    canCreateRequest () {
      return !!this.actionStruct &&
        (!this.isTowerCo() || this.isManager('project|finance|admin'))
    },

    formatStatus (value) {
      var color = ''

      switch (value) {
        case 'Closed':
          color = '#67C23A'
          break

        case 'Rejected':
          color = '#E6A23C'
          break

        default:
          color = '#606266' // '#303133'

      }

      return '<span style="color: ' + color + '">' + value + '</span>'
    },

    formatStep (value) {
      let cls = ''

      switch (value) {
        case 'RTS':
          cls = 'success'
          break

        case 'RTU':
          cls = 'primary'
          break

        case 'RTB':
          cls = 'info'
          break

          case 'RTA':
            cls = 'warning'
            break

         case 'RTD':
           cls = 'danger'
           break

      }

      return cls
    },

    formatRequest (value) {
      let cls = ''

      switch (value) {
        case 'RTS':
          cls += 'text-success'
          break

        case 'RTU':
          cls += 'text-primary'
          break

        case 'RTB':
          cls += 'text-info'
          break

          case 'RTA':
            cls += 'text-warning'
            break

            case 'RTD':
              cls += 'text-danger'
              break


      }

      return cls
    },

    formatBG (value) {
      let cls = ''

      switch (value) {
        case 'RTA':
          cls += 'bg-warning-lighten-2'
          break

        case 'RTS':
          cls += 'bg-success-lighten-2'
          break

        case 'RTU':
          cls += 'bg-primary-lighten-1'
          break

        case 'RTB':
          cls += 'bg-info-lighten-2'
          break

        case 'RTD':
           cls += 'bg-danger-lighten-2'
           break

      }

      return cls
    },

    // Method name retains legacy "progessBar" spelling (missing 'r') —
    // the slot template references this exact identifier, and renaming
    // would diverge from `main`'s template payload without behavior change.
    // Intentional, do not rename.
    progessBar (value) {
      let cls = '#C6E2FF'

      switch (value) {
        case 'RTA':
          cls = '#E6A23C'
          break

        case 'RTS':
          cls = '#67C23A'
          break

        case 'RTU':
          cls = '#409EFF'
          break

        case 'RTB':
          cls = '#909399'
          break

      case 'RTD':
         cls = 'indianred'
         break

      }

      return cls
    },

    formatDays (value) {
      var color = '#606266'

      if (value < 0) {
        color = 'indianred'
      }

      return '<span style="color: ' + color + '">' + value + '</span>'
    },

    formatPeriod (value) {
      var color = '#606266'

      if (value === 'Finished') {
        color = '#67C23A'
      }

      if (value === 'Overdue') {
        color = 'indianred'
      }

      if (value === 'Month') {
        color = 'slateblue'
      }

      if (value === 'Week') {
        color = 'goldenrod'
      }

      return sanitiseHtml('<b style="color: ' + color + '">' + value + '</b>')
    },

    changed (req) {
      this.reqStatus = req
      // reqStatus mutates → :url recomputes → xolas-table gets new prop →
      // explicit refresh ensures refetch even if url string stays identical
      this.$nextTick(function () {
        if (this.$refs.reqTable) {
          this.$refs.reqTable.refresh()
        }
      }.bind(this))
    },

    applySort () {
      this.$nextTick(function () {
        if (this.$refs.reqTable) {
          this.$refs.reqTable.refresh()
        }
      }.bind(this))
    }

  },


  computed: {
    // Null-safe wrapper for getTableStruct('actions'). Meta is loaded from
    // an async bootstrap XHR; calling getTableStruct() in the template before
    // hydration throws (getMeta returns null, .struct on null crashes render).
    // Returns null until meta is ready; the v-if on <request-action> defers
    // mount until the struct exists.
    actionStruct () {
      try {
        const meta = this.getMeta && this.getMeta('actions')
        return meta && meta.struct ? this.clone(meta.struct) : null
      } catch (e) {
        return null
      }
    }
  },


  watch: {

    sharer: function (value) {
      this.telcoId = value
      this.$nextTick(function () {
        if (this.$refs.reqTable) {
          this.$refs.reqTable.refresh()
        }
      }.bind(this))
    }

  },


  data () {
    return {
      reqStatus: this.status,

      telcoId: this.sharer,

      // sort dropdown + asc/desc switch — mirrors legacy DataTableFilterBar.
      // Pipe-formatted into `:sort-field` (e.g. "targetDate|desc") so the API's
      // explode('|', sort) gets [field, direction].
      sortField: 'targetDate',
      sortDir: 'desc',
      sortOptions: [
        { value: 'targetDate', label: 'Target Date' },
        { value: 'Period', label: 'Period' },
        { value: 'status', label: 'Status' },
        { value: 'siteName', label: 'Site Name' },
        { value: 'currentStep', label: 'Current Step' },
        { value: 'shortName', label: 'Organisation' }
      ],

      fields: [
        {
          name: '__slot:request-details',
          title: '',
          minWidth: '600'
        },
        {
          name: '__slot:rts-controls',
          title: '',
          width: '60',
          visible: this.isTowerCo()
        }
      ]
    }
  },


  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}
</script>

<style scoped>
/* Empty state — Element UI 2.x has no <el-empty>; hand-rolled. */
.requests-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  color: #909399;
}
.requests-empty__icon {
  font-size: 48px;
  color: #DCDFE6;
}
.requests-empty__text {
  margin: 12px 0 0;
  font-size: 14px;
}
.requests-empty__sub {
  margin-top: 4px;
  font-size: 12px;
  color: #C0C4CC;
}

/* RequestStats filter strip — sits in #below-filter slot, between search
   and rows. No card chrome (matches main): el-row provides the tinted
   bg-bordered background and the row's natural height. */
.request-stats {
  margin: 8px 0 0;
}
/* Sort row — mirrors legacy DataTableFilterBar's sort strip:
   #F2F6FC tinted bg, tight padding, negative margin-top so the strip
   visually merges with the RequestStats above. */
.request-sort-bar {
  background-color: #F2F6FC;
  width: 100%;
  padding: 0.528em;
  margin-top: -16px;
  margin-bottom: 12px;
}
.request-sort-bar__select {
  width: 100%;
}
</style>
